/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIReasonEnum } from './APIReasonEnum';
import {
    APIReasonEnumFromJSON,
    APIReasonEnumFromJSONTyped,
    APIReasonEnumToJSON,
} from './APIReasonEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIInventoryMovement
 */
export interface APIInventoryMovement {
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovement
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovement
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovement
     */
    target: string;
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovement
     */
    readonly user: string;
    /**
     * 
     * @type {Date}
     * @memberof APIInventoryMovement
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIInventoryMovement
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIInventoryMovement
     */
    readonly timestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof APIInventoryMovement
     */
    amount: number;
    /**
     * 
     * @type {APIReasonEnum}
     * @memberof APIInventoryMovement
     */
    reason?: APIReasonEnum | null;
}



/**
 * Check if a given object implements the APIInventoryMovement interface.
 */
export function instanceOfAPIInventoryMovement(value: object): value is APIInventoryMovement {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIInventoryMovementFromJSON(json: any): APIInventoryMovement {
    return APIInventoryMovementFromJSONTyped(json, false);
}

export function APIInventoryMovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIInventoryMovement {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'source': json['source'],
        'target': json['target'],
        'user': json['user'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'timestamp': (new Date(json['timestamp'])),
        'amount': json['amount'],
        'reason': json['reason'] == null ? undefined : APIReasonEnumFromJSON(json['reason']),
    };
}

export function APIInventoryMovementToJSON(value?: Omit<APIInventoryMovement, 'self'|'user'|'created_at'|'last_modified_at'|'timestamp'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'source': value['source'],
        'target': value['target'],
        'amount': value['amount'],
        'reason': APIReasonEnumToJSON(value['reason']),
    };
}

